export const notificationRequestUrls = (state) => state.notificationRequestUrls;
